import { Component, type ErrorInfo, type ReactNode } from 'react';
import { defineMessages } from '../i18n/define';
import { tr } from '../i18n/runtime';

const m = defineMessages({
  failed: { id: 'ai.boundary.failed', defaultMessage: 'Панель ИИ не загрузилась — скорее всего, обновилась версия приложения.', description: 'Карточка вместо панели ИИ, когда панель упала при отрисовке (все роли); одно-два предложения' },
  reload: { id: 'ai.boundary.reload', defaultMessage: 'Обновить страницу', description: 'Кнопка в карточке сбоя панели ИИ: перезагрузить страницу; коротко' },
  retry: { id: 'ai.boundary.retry', defaultMessage: 'Повторить', description: 'Кнопка в карточке сбоя панели ИИ: попробовать отрисовать панель снова; коротко' },
});

interface State {
  failed: boolean;
}

/**
 * Граница ошибок панели ИИ. Панель живёт вне границы маршрута (поверх всех
 * экранов), поэтому без своей границы любой сбой внутри неё — например, не
 * догрузившийся лениво модуль отрисовки ответа после обновления сборки —
 * ронял всё приложение в белый экран. Теперь падает только панель: на её
 * месте остаётся маленькая карточка с повтором.
 */
export class AgentPanelBoundary extends Component<{ children: ReactNode }, State> {
  state: State = { failed: false };

  static getDerivedStateFromError(): State {
    return { failed: true };
  }

  componentDidCatch(error: unknown, info: ErrorInfo): void {
    if (import.meta.env.DEV) console.warn('[agent] панель ИИ не отрисована:', error, info.componentStack);
  }

  render(): ReactNode {
    if (!this.state.failed) return this.props.children;
    return (
      <div role="alert" className="agent-panel-failed">
        <span>{tr(m.failed)}</span>
        <button type="button" className="btn btn--secondary btn--sm focus-ring" onClick={() => window.location.reload()}>
          {tr(m.reload)}
        </button>
        <button type="button" className="btn btn--ghost btn--sm focus-ring" onClick={() => this.setState({ failed: false })}>
          {tr(m.retry)}
        </button>
      </div>
    );
  }
}
